import axios from 'axios';
import store from '@/store';

class EtiquetasServices {
    constructor() {
        this.api = axios.create({
            baseURL: process.env.VUE_APP_ENV === 'development'
                ? process.env.VUE_APP_API_CONSULTA_ESTOQUE_URL
                : `${location.protocol}//${location.host}${process.env.VUE_APP_API_CONSULTA_ESTOQUE_URL}`,
            timeout: +process.env.VUE_APP_REQUEST_TIMEOUT * 1000,
        });

        this.api.interceptors.request.use((config) => {
            const token = localStorage.getItem('jwtToken');
            if (token) {
                config.headers['Authorization'] = `Bearer ${token}`;
            }
            return config;
        }, (error) => {
            return Promise.reject(error);
        });

        this.api.interceptors.response.use(
            (response) => response.data,
            (error) => {
                return Promise.reject(error);
            }
        );
    }

    buscarProdutoEtiqueta(params) {
        return this.api.get('/produto-etiqueta', { params });
    }

    buscarEmbalagemEtiqueta(params) {
        return this.api.get('/embalagem-etiqueta', { params });
    }

    buscarListagemEtiqueta(params) {
        params["cod_filial"] = store.getters.getCodigoLojaSenior;
        return this.api.get('/listagem-etiqueta', { params });
    }

    listarModelosEtiquetas() {
        const params = {};
        params["id_empresa"] = localStorage.getItem('id_empresa')
        return this.api.get('/listar-modelos-etiquetas', {params})
            .then(modelos => modelos)
            .catch(error => {
                console.error("Erro ao buscar os modelos de etiquetas:", error);
                return Promise.reject(error);
            });
    }

    pesquisarEtiqueta(dados) {
        return this.api.post('/etiquetas/pesquisa/', dados)
            .then(response => response)
            .catch(error => {
                console.error("Erro ao realizar a pesquisa de etiquetas:", error);
                return Promise.reject(error);
            });
    }

}

export default new EtiquetasServices();
